<shared-modal-type-dynamic-height [minHeight]="10" [modalData]="modalData" [center]="true" [mobilePreserve]="true"
    [size]="size" (onCloseClick)="handleCloseClick($event)" class="modal-for-active-order">

    <shared-header [center]="true" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
        class="modal-for-active-order__sub-h">
        {{ 'You have an active order at:' | uppercase }}
    </shared-header>
    <shared-header [center]="true" class="modal-for-active-order__h" type="2" marginTop="xs" marginBottom="md">
        {{cartLocationName$ | async}}
    </shared-header>

    <div class="modal-for-active-order__content">
        Adding items from a new store
        <!-- <shared-link class="modal-for-active-order__link" (onClick)="handleNewStoreClick($event)"
            [emphasis]="false">new store</shared-link> -->
        <br />or changing the pick-up time will start a new order,
        <br />and current order will be lost.
    </div>

    <div class="modal-for-active-order__actions">
        <ng-template #twoColumnsLeft>
            <shared-btn feel="secondary" [width]="'extended'" size="lg" (onClick)="handleContinueOrder($event)">Continue
                order</shared-btn>
        </ng-template>

        <ng-template #twoColumnsRight>
            <shared-btn [width]="'extended'" size="lg" (onClick)="handleStartNewOrder($event)">Start new order
            </shared-btn>
        </ng-template>

        <shared-two-columns [left]="twoColumnsLeft" [right]="twoColumnsRight"></shared-two-columns>
    </div>

</shared-modal-type-dynamic-height>
